import type { PortableTextTypeComponentProps } from '@portabletext/react';
import { TableRenderer, type TableValue } from './TableRenderer';

// Server boundary for the client-side TableRenderer: PortableText hands custom type
// components a `renderNode` callback, and functions cannot be passed to a Client
// Component. Forwarding only the serializable value keeps the boundary clean.
export function TableBlock({ value }: PortableTextTypeComponentProps<TableValue>) {
    return <TableRenderer value={value} />;
}
